module.exports = __webpack_public_path__ + "img/52.2820bf06.jpg";